exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".featured-search-wrapper[data-v-af070d68]{column-count:4;width:100%}.area-group[data-v-af070d68]{-webkit-column-break-inside:avoid;page-break-inside:avoid;break-inside:avoid}@media(max-width:992px){.featured-search-wrapper[data-v-af070d68]{max-height:450px;overflow-y:auto;overflow-x:hidden;display:flex;flex-direction:column}}", ""]);

// exports
